import React from "react";
import { useLang } from "../context/LanguageContext";

export default function Process() {
  const { t } = useLang();
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-[#0A0A0A] py-24 md:py-32 px-6 md:px-12 border-t border-white/5"
    >
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-6">
            <p className="font-mono-tight text-zinc-500 mb-6">{t.process.label}</p>
            <h2 className="text-5xl md:text-7xl font-display tracking-tighter text-white" data-testid="process-title">
              {t.process.title}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-white/10">
          {t.process.steps.map((s, i) => (
            <div
              key={s.num}
              data-testid={`process-step-${s.num}`}
              className="relative p-8 md:p-10 border-b lg:border-b-0 lg:border-r border-white/10 last:border-r-0 group hover:bg-white/[0.02] transition-colors"
            >
              <div className="font-mono-tight text-zinc-600 mb-12">{s.num}</div>
              <div className="text-3xl md:text-4xl font-light tracking-tight text-white mb-6">
                {s.name}
              </div>
              <p className="text-zinc-500 text-sm leading-relaxed">{s.desc}</p>
              <div className="absolute top-8 right-8 w-2 h-2 bg-zinc-700 group-hover:bg-white transition-colors rounded-full" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
